module.exports = __webpack_public_path__ + "static/media/plaque_va_2024.096b8e96.png";